import { render } from "./DashboardPage.vue?vue&type=template&id=5b87ac46"
import script from "./DashboardPage.vue?vue&type=script&lang=js"
export * from "./DashboardPage.vue?vue&type=script&lang=js"
script.render = render

export default script